export const industrialTemplateIds = {
    '97177' : true,
    '97180' : true,
    '97182' : true,
    '97183' : true,
    '97178' : true,
    '97216' : true,
    '97184' : true,
    '97186' : true,
    '97188' : true,
    '97194' : true,
    '97203' : true,
    '97205' : true,
    '97217' : true,
    '97199' : true,
    '97197' : true,
} 





// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/industrial-template-ids.ts